// extracted by mini-css-extract-plugin
module.exports = {"option":"RoomsSelect_option__3SQFu","optionActions":"RoomsSelect_optionActions__rfBFX","roomsCount":"RoomsSelect_roomsCount__1Mkxr","removeIcon":"RoomsSelect_removeIcon__7_I4d"};